// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","correct":"Modal_correct__mP9zR","incorrect":"Modal_incorrect__SHOA5","loader":"Modal_loader__ubvfC","l6":"Modal_l6__r+hS1"};